<template>
    <div>
      <div class="text-center py-3">
          <h2>SignUp</h2>
          <b-list-group horizontal class="flex-center">
              <b-list-group-item>약관동의</b-list-group-item>
              <b-list-group-item variant="primary">본인인증</b-list-group-item>
              <b-list-group-item>정보입력</b-list-group-item>
              <b-list-group-item>가입완료</b-list-group-item>
          </b-list-group>
      </div>
      <div> 
        <div class="content text-center p-3"> 
            <h5>본인인증 후 가입이 가능합니다.</h5>
            <div class="authbox my-3">
                <div class="boxcontent">
                    <div>휴대폰 인증</div>
                    
                    <button class="md-button" @click="this.$router.push('/signup/inputinfo')">인증하기</button>
                </div>
                <div class="boxcontent">
                    <div>PASS 인증</div>
                    <button class="md-button" @click="this.$router.push('/signup/inputinfo')">인증하기</button>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>
<style scoped>
    .authbox{
        display: inline-block;

    }
    .boxcontent{
        border: 1px solid lightblue;
        float: left;
        padding: 20px;
        margin: 0px 5px;
    }
</style>